import { Outlet } from 'react-router-dom';
import CompanyNav from '@composites/Headers/CompanyNav';
import PortfolioOverviewFooter from '@composites/Footers/PortfolioOverviewFooter';

const CompanyLayout = () => {
  return (
    <>
      <CompanyNav />
      <Outlet />
      <PortfolioOverviewFooter />
    </>
  );
};

export default CompanyLayout;
